import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/products/ai-shade-finder"
    exact
    path="/business/products/ai-shade-finder"
    component={AsyncPage}
  />,
  // <Route
  //   key="/ja/business/products/ai-shade-finder"
  //   exact
  //   path="/ja/business/products/ai-shade-finder"
  //   newsmb={AsyncPage}
  // />,
];
